import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { UpdateRecipientSchema } from '@app/models/dictionaries';
import Api from '@app/services/api';

interface IParams {
  uid: string;
  data: UpdateRecipientSchema;
}

export const useUpdateRecipientQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ uid, data }: IParams) => {
      const resp = await Api.dictionaries.putRecipient(uid, data);
      return resp;
    },
    onSuccess: async (resp, data) => {
      await client.invalidateQueries(['getRecipient', data?.uid]);
      message.open({
        type: 'success',
        content: commonT.t('dataPatchSuccess'),
      });
    },
    onError: () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
  });
};
